var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.544 3.19L8.309 1.955 3.688 6.576l-1.711-1.71L.742 6.1 3.07 8.428a.873.873 0 001.235 0L9.544 3.19z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/landing/check-icon-a7b21d46.svg";
export { SvgCheckIcon as ReactComponent };